import useTransferRoute from './useTransferRoute';
import useTransportLocationGetByID from "./useTransportLocationGetByID";
interface TransferRouteGetDepartureParams {
    cityId?: number;
    departureLocationFrom?: number;
    departureLocationTo?: number;
    execute?: boolean;
}
/**
 * Hook to get transfer routes for DEPARTURE
 * Wraps the generic useTransferRoute hook with specific names for DEPARTURE
 */
export default function useTransferRouteGetDeparture(
    params: TransferRouteGetDepartureParams
) {
    const { cityId, departureLocationFrom, departureLocationTo, execute = true } = params;

    // Get individual locations to verify parentLocation
    const { data: fromLocation } = useTransportLocationGetByID(
      departureLocationFrom,
      { execute: !!departureLocationFrom }
    );
    const { data: toLocation } = useTransportLocationGetByID(
      departureLocationTo,
      { execute: !!departureLocationTo }
    );

    // Wait for both locations to finish loading before executing
    const bothLocationsLoaded = (!!departureLocationFrom ? !!fromLocation : true) &&
      (!!departureLocationTo ? !!toLocation : true);

    return useTransferRoute({
        cityId,
        locationFrom: fromLocation,
        locationTo: toLocation,
        execute: execute && bothLocationsLoaded,
    });
}
